/**
 * @desc 托盘列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inPlateMaster.list.Params, options?: any) {
  return updateResponse(
    http(URL + `/inPlate`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
